import { InitService } from './init.service';

export function initServiceFactory(initService: InitService): () => void {
  return () => initService.init();
}
